module.exports = __webpack_public_path__ + "static/media/sf-test-8.a161f4a8.mp3";